import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatLabel } from '@angular/material/form-field';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { Resolution } from '@api-types/enums/resolution.enum';
import { FormFieldComponent, FormInputDateComponent } from '@libs/ui';
import { TranslateModule } from '@ngx-translate/core';
import {
  ForecastVersionSettingsForm,
  ForecastVersionSettingsFormControlNames,
} from 'demand-forecasting/components/forms/forecast-version-settings-form.interface';

@Component({
  selector: 'pm-forecast-version-settings',
  templateUrl: './forecast-version-settings.component.html',
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    MatLabel,
    MatRadioButton,
    MatRadioGroup,
    MatSlideToggle,
    FormFieldComponent,
    FormInputDateComponent,
  ],
})
export class ForecastVersionSettingsComponent {
  @Input()
  forecastVersionSettingsFormGroup: FormGroup<ForecastVersionSettingsForm>;

  protected readonly ForecastVersionSettingsFormControlNames =
    ForecastVersionSettingsFormControlNames;

  protected readonly Resolution = Resolution;

  // Beispiel wie sich das includeDataUntil-Feld auswirkt:
  // Wenn die Daten bis Januar 2024 gehen und ein einmonatiger Forecast mit max date 2023-06-30 erstellt wird,
  // wird ein Modell mit den Daten bis Juni 2023 trainiert und damit ein Forecast für Juli 2023 erstellt.
}
